import angular from 'angular';
import marryContactsModal from './marryContactsModal';

export default angular
  .module('mergeContact.scene.marryContacts.components', [])
  .component('marryContactsModal', marryContactsModal).name;
